<template>
  <svg :class="name" xmlns="http://www.w3.org/2000/svg" @click="click">
    <title v-if="title">{{ title }}</title>
    <use :xlink:href="iconPath" xmlns:xlink="http://www.w3.org/1999/xlink" />
  </svg>
</template>

<script>
  import remixiconSpriteUrl from 'remixicon/fonts/remixicon.symbol.svg';

  export default {
    name: 'Remixicon',
    props: {
      name: {
        type: String,
        required: true
      },
      title: {
        type: String,
        default: null
      }
    },
    computed: {
      iconPath () {
        return `${remixiconSpriteUrl}#${this.name}`;
      }
    },
    methods: {
      click () {
        this.$emit('click');
      }
    }
  };
</script>

<style lang="scss" scoped>
  svg {
    fill: currentColor;
    height: 24px;
    width: 24px;
  }
</style>
